import { ApiRole } from '@reliance/types/models/ApiRole';
import type {
  LoaderFunctionArgs,
  RouteObject,
  UIMatch,
} from 'react-router-dom';
import api from '../common/api';
import { lazyElement } from '../routing/lazyRoute';

const apiRoleRoutes: RouteObject[] = [
  {
    path: '/api-role',
    element: lazyElement(() => import('./Main')),
    handle: {
      crumb: () => ({ label: 'API Roles', to: '/api-role' }),
    },
  },
  {
    path: '/api-role/:id',
    element: lazyElement(() => import('./View')),
    loader: async ({params}: LoaderFunctionArgs) => {
      const id = Number(params.id);
      if (!Number.isFinite(id) || id <= 0) {
        throw new Response('Invalid API role id', { status: 400 });
      }
      try {
        const res = await api.get<ApiRole>(`/api-role/${id}`);
        return res.data;
      } catch (e: unknown) {
        const status = (e as { response?: { status?: number } })?.response?.status;
        if (status === 404) {
          throw new Response(`API role with ID ${id} not found`, { status: 404 });
        }
        throw e;
      }
    },
    handle: {
      crumb: (match: unknown) => {
        const role = (match as UIMatch).data as ApiRole | undefined;
        const label = role?.name ?? 'API Role';
        return {
          label,
          to: role?.id != null ? `/api-role/${role.id}` : undefined,
        };
      },
    },
  },
];

export default apiRoleRoutes;
